export * from './types';
export * from './compareUrl';
export * from './resolveRows';
export { CompareProvider, useCompare } from './CompareProvider';
export type {
  CompareContextValue,
  CompareProviderProps,
} from './CompareProvider';
export { CompareToggle } from './CompareToggle';
export { CompareListingProvider } from './CompareListing';
export { CompareTogglePill } from './CompareTogglePill';
export { CompareTray } from './CompareTray';
export { ComparePage } from './ComparePage/ComparePage';
export { CompareEmptyState } from './ComparePage/CompareEmptyState';
export * from './compareVariant';
export * from './compareCandidates';
// The block's copy, for the route's server-side metadata (the page title).
export { TRANSLATIONS as COMPARE_TRANSLATIONS } from './i18n';
export type { ComparePageProps } from './ComparePage/ComparePage';
// The key and the record's shape, for tests that seed the round trip; reading and writing the
// record is the provider's alone.
export { compareStorageKey } from './compareStorage';
export type { CompareStored } from './compareStorage';
